<template>
  <div id="hres72u">
    <hrms-search-box-table v-show="indexDisp"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres72uIndex"
            searchBoxAlias="approve"
            :detailEvent="detailEvent"
            :approveEvent="approveEvent"
            :approveRowBool="true" />

    <detail v-show="detailDisp"
            :labels="labels[dash.nowLang]"
            :labelsButton="dash.button[dash.nowLang]"
            :detail="detail"
            :codempid="codempid"
            :tab2Table="columns[dash.nowLang].detailTab2"
            :toggle="toggle"
            :nowLang="dash.nowLang"
            :detailTab2Popup="detailTab2Popup"
            :receivedHres72uDetailTab2Popup="receivedHres72uDetailTab2Popup" />

    <div class="form-group-button" v-show="false">
      <button class="btn bg-blue" data-toggle="modal" ref="approve" data-target="#hres72u-popup-approve"><i class="fa fa-list-alt"></i> {{ btn_approve }}</button>
    </div>

    <popup-approve :labels="labels[dash.nowLang]"
            :nowLang="dash.nowLang"
            :labelsButton="dash.button[dash.nowLang]"
            :postHres72uSendApprove="postHres72uSendApprove"
            :indexSelected="indexSelected"
            :codappr="codempid"
            :detailSubmit="detailSubmit"
            :descCodappr="dash.currentUser.username[dash.nowLang]" />

  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres72u/mutation-types'
import detail from 'components/hres72u/detail'
import popupApprove from 'components/hres72u/popupApprove'
import moment from 'moment'
import swal from 'sweetalert'

export default {
  name: 'hres72u',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      btn_approve: 'Approve'
    }
  },
  created () {
    this.receivedHres72uColumnsLabels()
    this.receivedHres72uIndex()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES72U_INDEX_DISP,
      detailDisp: types.GET_HRES72U_DETAIL_DISP,
      columns: types.GET_HRES72U_COLUMNS,
      labels: types.GET_HRES72U_LABELS,
      index: types.GET_HRES72U_INDEX,
      indexSelected: types.GET_HRES72U_INDEX_SELECTED,
      detail: types.GET_HRES72U_DETAIL,
      detailTab2Popup: types.GET_HRES72U_DETAIL_TAB2_POPUP,
      detailSubmit: types.GET_HRES72U_DETAIL_SUBMIT
    })
  },
  methods: {
    pageDetail (event) {
      let detailParams = this.indexSelected
      this.receivedHres72uDetail(detailParams)
      this.toggle('detail')
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    approveEvent (dataRows) {
      let dataRowsFiltered = dataRows.filter(function (dataRow) {
        return dataRow.flgStaappr !== 'undefined' && dataRow.flgStaappr !== 'P' && dataRow.flgStaappr.trim() !== ''
      })
      if (dataRowsFiltered.length > 0) {
        this.setIndexSelected(dataRowsFiltered[0])
        this.receivedHres72uDetailSubmit(this.indexSelected)
        this.$refs.approve.click()
      } else {
        swal({
          title: 'ยืนยันการทำรายการ',
          text: 'รายการยังไม่ถูกเลือก'
        })
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES72U_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES72U_PAGE,
      receivedHres72uColumnsLabels: types.RECEIVED_HRES72U_COLUMNS_LABELS,
      receivedHres72uIndex: types.RECEIVED_HRES72U_INDEX,
      receivedHres72uDetail: types.RECEIVED_HRES72U_DETAIL,
      receivedHres72uDetailTab2Popup: types.RECEIVED_HRES72U_DETAIL_TAB2_POPUP,
      receivedHres72uDetailSubmit: types.RECEIVED_HRES72U_DETAIL_SUBMIT,
      postHres72uSendApprove: types.POST_HRES72U_SEND_APPROVE
    })
  },
  components: {
    detail,
    popupApprove
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?50160872